import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { CompanyBranchService } from 'src/app/configurations/company-branch/company-branch.service';
import { ImportserialService } from 'src/app/modules/shared/services/importserial.service';

@Component({
  selector: 'app-edit-exchangerate',
  templateUrl: './edit-exchangerate.component.html',
  styleUrl: './edit-exchangerate.component.scss'
})
export class EditExchangerateComponent implements OnChanges {

  @Input() vendorCurrencyExchangeRate: number;
  @Input() vendorDetails = null;
  @Input() orgCurrency = [];
  @Output() closeDialog = new EventEmitter<any>();
  previousRate: number | null = null;
  exchangeForm: FormGroup;
  todaysData: Date = new Date();

  constructor(private fb: FormBuilder, private app: AppMainComponent,
    private messageService: MessageService, private companyService: CompanyBranchService,
    private importService: ImportserialService, private appMainService: AppMainService) { }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.orgCurrency?.currentValue || changes?.vendorCurrencyExchangeRate?.currentValue) {
      this.prepareExchangeForm();
      this.editValue();
    }
  }

  prepareExchangeForm() {
    this.exchangeForm = this.fb.group({
      id: [0],
      name: [''],
      code: [''],
      organizationId: [0],
      currencyId: [0],
      countryId: [0],
      symbol: [''],
      isBaseCurrency: [false],
      exchangeRate: [1, [Validators.required, Validators.min(0.000001)]],
      statusId: [1],
      defaultRateEnabled: [false],
      enableRecalculateItemRate: [false],
      exchangeRateUpdatedDate: [new Date()],
      exchangeRateUpdatedBy: [0],
      createdSource: [null],
      updatedSource: [null],
      createdBy: [0],
      updatedBy: [0],
      createdDate: [new Date()],
      updatedDate: [new Date()]
    }, { validators: this.atLeastOneCheckboxChecked })
  }

  // Custom Validator to Ensure One Checkbox is Checked
  atLeastOneCheckboxChecked(form: AbstractControl) {
    const defaultRate = form.get('defaultRateEnabled')?.value;
    const recalculateRate = form.get('enableRecalculateItemRate')?.value;
    return defaultRate || recalculateRate ? null : { atLeastOneRequired: true };
  }

  editValue() {
    const orgCurrency = this.orgCurrency?.find(cr => cr.currencyId == this.vendorDetails?.currencyId);
    this.exchangeForm.patchValue(orgCurrency);
    this.exchangeForm.controls['exchangeRate'].setValue(this.vendorCurrencyExchangeRate);
    this.exchangeForm.controls['defaultRateEnabled'].setValue(false);
    this.exchangeForm.controls['enableRecalculateItemRate'].setValue(false);
  }

  updateRate(newRate: number) {
    if (this.vendorCurrencyExchangeRate !== newRate) { 
        // Update previousRate only if there's a real change
        this.previousRate = this.vendorCurrencyExchangeRate;
        this.vendorCurrencyExchangeRate = newRate;
    }else{
     this.previousRate = this.vendorCurrencyExchangeRate;
    }
}

  saveExchangeRate(value) {
    this.updateRate(value.exchangeRate)
    const returnObj = {
      formData: value,
      previousExchangeRate: this.previousRate
    }
    if (value.defaultRateEnabled) {
      value.exchangeRateUpdatedDate =
        (this.vendorCurrencyExchangeRate === value.exchangeRate)
          ? value.exchangeRateUpdatedDate
          : this.app._saveDateTimeWithZone(new Date());
      value.exchangeRateUpdatedBy =
        (this.vendorCurrencyExchangeRate === value.exchangeRate)
          ? value.exchangeRateUpdatedBy
          : this.app.user.userId;
      value.createdSource = (value.createdSource) ? value.createdSource : this.app.userIP
      this.appMainService.isShowSpinner('latestData');
      this.companyService.updateCurrency(value).subscribe({
        next: (res) => {
          // Handle success
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Updated Successfully...",
          });
          this.companyService.getAllCurrencies().subscribe({
            next: (currencyList) => {
              this.appMainService.isHideSpinner('latestData');
              this.importService.setOrgCurrency(currencyList);
              this.closeDialog.emit(returnObj);
            },
            error: (err) => {
              console.error('Error fetching organization data:', err);
              this.appMainService.isHideSpinner('latestData'); // Ensure spinner is hidden even on error
              // Handle the error appropriately, e.g., show a message to the user
            }
          });
        },
        error: (error) => {
          // Handle error
          this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: "An error occurred while updating the currency.",
          });
          console.error('Update Currency Error:', error); // Log the error for debugging
        }
      });
    } else {
      this.exchangeForm.controls['enableRecalculateItemRate'].setValue(false);
      this.closeDialog.emit(returnObj);
    }
  }

}
